// Detects multi-line declaration starts for semicolon warning suppression.
// Example: `background: linear-gradient(` should not warn on the first line.
import { startsDeclarationAt } from './declarations'

// Check whether a declaration line continues onto following non-empty lines.
export function isMultilineDeclarationContinuationStart(lines: string[], lineIndex: number): boolean {
  const current = lines[lineIndex]?.trim() ?? ''
  // Return false when the current line is not a declaration start.
  if (!current || !startsDeclarationAt(current, 0)) {
    return false
  } else {
    // Continue next-line continuation checks.
  }

  const nextIndex = findNextMeaningfulLineIndex(lines, lineIndex + 1)
  // Return false when the declaration has no following non-empty line.
  if (nextIndex === -1) {
    return false
  } else {
    // Continue continuation classification for the next line.
  }

  const next = lines[nextIndex].trim()
  // Reject next lines that clearly start a new statement or block.
  if (
    !next
    || next.startsWith('}')
    || next === '{'
    || next.endsWith('{')
    || next.startsWith('@')
    || startsDeclarationAt(next, 0)
    || next.includes('&var(')
    || /^var\(\s*--/.test(next)
  ) {
    return false
  } else {
    // Treat other next-line forms as declaration continuation content.
    return true
  }
}

// Find the next non-empty line index after the provided cursor.
function findNextMeaningfulLineIndex(lines: string[], fromIndex: number): number {
  // Scan forward and return the first non-empty trimmed line index.
  for (let index = fromIndex; index < lines.length; index += 1) {
    if (lines[index].trim().length > 0) {
      return index
    } else {
      // Continue while line is empty/whitespace only.
    }
  }

  // Return -1 when no following non-empty line exists.
  return -1
}
